exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-offline-badge[data-v-452f12b6]{position:fixed;bottom:0;left:0;right:0;z-index:3;border-radius:0;max-width:none;-ms-flex-pack:center;justify-content:center}\n", ""]);

// exports
